import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NoColumnLayoutComponent } from '../core/layouts';

@Component({
    standalone: true,
    selector: 'ngx-auth',
    template: `<ngx-no-column-layout>
        <router-outlet></router-outlet>
    </ngx-no-column-layout>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule, NoColumnLayoutComponent]
})
export class AuthComponent {}
